import policy from 'Agent/Policies/ducks/policy';
import policyApplications from 'Agent/Policies/ducks/policyApplications';
import policyCorrespondence from 'Agent/Policies/ducks/policyCorrespondence';
import policyServiceRequest from 'Agent/Policies/ducks/policyServiceRequest';

export default {
  policy,
  policyCorrespondence,
  policyServiceRequest,
  policyApplications,
};
